// extracted by mini-css-extract-plugin
export default {"control-wrapper":"style_control-wrapper__KaAQz","rippleEffect":"style_rippleEffect__gzFcL"};